import { render, staticRenderFns } from "./HotspotPanorama.vue?vue&type=template&id=4ea9dafc&shadow"
import script from "./HotspotPanorama.vue?vue&type=script&lang=ts&shadow"
export * from "./HotspotPanorama.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./HotspotPanorama.vue?vue&type=style&index=0&id=4ea9dafc&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports